<template>
    <div class="content-page fluid-container">
        <pulte-banner class="mt-3" title=" MY ACCOUNT"></pulte-banner>
        <login-section :redirect-uri="redirectUri"></login-section>
        <have-questions contactUsUrl="/contact"></have-questions>
        <family-of-brands :familyOfBrandLinks="familyOfBrandLinks"></family-of-brands>
    </div>
</template>

<script>
    import LoginSection from '../components/sections/login/LoginSection.vue';

    import { mapGetters } from 'vuex';

    export default {
        name: 'login',
        analyticsCategory: 'Login',
        components: {
            'login-section': LoginSection
        },
        props: {
            redirectUri: { type: String, default: '' }
        },
        computed: {
            ...mapGetters(['familyOfBrandLinks'])
        }
    }
</script>
<style lang="scss">
    .btn-primary.pmbtn:focus {
        box-shadow: 0 0 0 .2rem #007bff40;
    }
</style>
